<template>
  <el-dialog
    :title="title?title:'提示'"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    width="360px"
    :before-close="handleClose">
    <EleForm
      ref="form"
      :form="newForm"
	    :is-submit="isSubmit"
      @onAttr="onAttr"
    ></EleForm>
    <!--    <IMUploadMul />-->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="isSubmit = true">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fields } from './fields'

export default {
  name: 'add-game',
  props: {
    title: String,
    visible: {
      type: Boolean,
      default: false
    },
    defaultValue: Object
  },
  watch: {
    visible (vl) { this.dialogVisible = vl },
    dialogVisible (vl) {
      this.$emit('update:visible', vl)
    },
    defaultValue (vl) { this.newDefaultValue = vl },
    newDefaultValue (vl) {
      this.$emit('update:defaultValue', vl)
    },
    form (vl) { this.newForm = this.$_.cloneDeepWith(vl) }
  },
  created () {
    // 如果是编辑，赋予初始值
    this.$nextTick(() => {
      if (this.newDefaultValue && this.newDefaultValue.isEdit) {
        this.newForm.forEach( v => {
          if (this.newDefaultValue.data[v.attr]) {
            v.value = this.newDefaultValue.data[v.attr]
          }
        })
      }
    })
  },
  data () {
    return {
      dialogVisible: this.visible,
      newForm: this.$_.cloneDeepWith(fields),
      newDefaultValue: this.defaultValue,

		isSubmit: false,
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    onAttr (valid, forms) {
      this.isSubmit = false;

      if (valid) {
        this.$emit('success', {
          isEdit: this.defaultValue.isEdit,
          name: forms.name,
          description: forms.description
        })
        this.handleClose()
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/typeSelect2/typeName/index.vue